import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { TimesheetEntry, TimesheetState } from '@sdk/timesheets/types/TimesheetEntry';
import getPendingTimesheetState from '@sdk/timesheets/helpers/getPendingTimesheetState';

import ManagerApprovedBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ManagerApprovedBanner';
import EmployeeViewPendingManagerApprovalBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/employee/EmployeeViewPendingManagerApprovalBanner';
import EmployeeViewConsentGivenBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/employee/EmployeeViewConsentGivenBanner';
import EmployeeViewEmployeeDeniedBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/employee/EmployeeViewEmployeeDeniedBanner';

type Props = {
  timesheetStatus: TimesheetStatus;
  timesheetEntries: TimesheetEntry[];
};
const TimesheetViewModalBannerEmployee = ({ timesheetStatus, timesheetEntries }: Props) => {
  if (timesheetStatus === TimesheetStatus.approved) {
    return <ManagerApprovedBanner />;
  }

  if (timesheetStatus === TimesheetStatus.pending) {
    const { state, consentDenyReason } = getPendingTimesheetState(timesheetEntries);

    if (state === TimesheetState.consentGiven) {
      return <EmployeeViewConsentGivenBanner />;
    }

    if (state === TimesheetState.consentDenied) {
      return <EmployeeViewEmployeeDeniedBanner consentDenyReason={consentDenyReason} />;
    }

    return <EmployeeViewPendingManagerApprovalBanner />;
  }

  return null;
};

export default TimesheetViewModalBannerEmployee;
